module.exports = __webpack_public_path__ + "static/Docker-7d122f47a81f7584af97b8366c838e31.svg";